module.exports = __webpack_public_path__ + "img/banner-38.f836f8b3.jpg";